<template>
    <div class="form-group m-form__group" v-bind:class="{'has-danger': hasDanger}" v-if="viewStyle == 1">
        <label v-bind:for="id">
            {{$t(label)}}
        </label>
        <InputTextComponent
                v-if="(type == 'text' || type == 'date' || type == 'email' || type == 'number')"
                v-bind:type="type"
                v-bind:name="name"
                v-bind:id="id"
                v-bind:placeholder="placeholder"
                v-bind:value="value"
                v-bind:inputClass="inputClass">
        </InputTextComponent>
        <SelectableComponent
                v-if="(type == 'select')"
                v-bind:type="type"
                v-bind:name="name"
                v-bind:id="id"
                v-bind:placeholder="placeholder"
                v-bind:value="value"
                v-bind:inputClass="inputClass"
                v-bind:options="options">
        </SelectableComponent>
        <TextareaComponent
                v-if="(type == 'textarea')"
                v-bind:type="type"
                v-bind:name="name"
                v-bind:id="id"
                v-bind:placeholder="placeholder"
                v-bind:value="value"
                v-bind:inputClass="inputClass">
        </TextareaComponent>
        <CheckboxComponent
                v-if="(type == 'checkbox')"
                v-bind:type="type"
                v-bind:name="name"
                v-bind:id="id"
                v-bind:placeholder="placeholder"
                v-bind:value="value"
                v-bind:inputClass="inputClass"
                v-bind:checkboxes="checkboxes">
        </CheckboxComponent>
        <RadioComponent
                v-if="(type == 'radio')"
                v-bind:type="type"
                v-bind:name="name"
                v-bind:id="id"
                v-bind:placeholder="placeholder"
                v-bind:value="value"
                v-bind:inputClass="inputClass"
                v-bind:radios="radios">
        </RadioComponent>
        <FileComponent
                v-if="(type == 'file')"
                v-bind:type="type"
                v-bind:name="name"
                v-bind:id="id"
                v-bind:placeholder="placeholder"
                v-bind:value="value"
                v-bind:inputClass="inputClass">
        </FileComponent>
        <div class="form-control-feedback">
            <span v-for="message in filter(name)" v-bind:key="message">
                {{message}} <br/>
            </span>
        </div>
        <span class="m-form__help">
            {{$t(helpText)}}
        </span>
    </div>
    <div v-else class="form-group m-form__group row" v-bind:class="{'has-danger': hasDanger}">
        <label v-bind:for="id" class="col-form-label col-lg-3">
            {{$t(label)}}
        </label>
        <div class="col-lg-9">
            <InputTextComponent
                    v-if="(type == 'text' || type == 'date' || type == 'email' || type == 'number')"
                    v-bind:name="name"
                    v-bind:id="id"
                    v-bind:placeholder="placeholder"
                    v-bind:value="value"
                    v-bind:inputClass="inputClass">
            </InputTextComponent>
            <SelectableComponent
                    v-if="(type == 'select')"
                    v-bind:type="type"
                    v-bind:name="name"
                    v-bind:id="id"
                    v-bind:placeholder="placeholder"
                    v-bind:value="value"
                    v-bind:inputClass="inputClass"
                    v-bind:options="options">
            </SelectableComponent>
            <TextareaComponent
                    v-if="(type == 'textarea')"
                    v-bind:type="type"
                    v-bind:name="name"
                    v-bind:id="id"
                    v-bind:placeholder="placeholder"
                    v-bind:value="value"
                    v-bind:inputClass="inputClass">
            </TextareaComponent>
            <CheckboxComponent
                    v-if="(type == 'checkbox')"
                    v-bind:type="type"
                    v-bind:name="name"
                    v-bind:id="id"
                    v-bind:placeholder="placeholder"
                    v-bind:value="value"
                    v-bind:inputClass="inputClass"
                    v-bind:checkboxes="checkboxes">
            </CheckboxComponent>
            <RadioComponent
                    v-if="(type == 'radio')"
                    v-bind:type="type"
                    v-bind:name="name"
                    v-bind:id="id"
                    v-bind:placeholder="placeholder"
                    v-bind:value="value"
                    v-bind:inputClass="inputClass"
                    v-bind:radios="radios">
            </RadioComponent>
            <FileComponent
                    v-if="(type == 'file')"
                    v-bind:type="type"
                    v-bind:name="name"
                    v-bind:id="id"
                    v-bind:placeholder="placeholder"
                    v-bind:value="value"
                    v-bind:inputClass="inputClass">
            </FileComponent>
            <div class="form-control-feedback">
                <span v-for="message in filter(name)" v-bind:key="message">
                    {{message}} <br/>
                </span>
            </div>
            <span class="m-form__help">
                {{$t(helpText)}}
            </span>
        </div>
    </div>
</template>

<script>
import InputTextComponent from './inputs/InputTextComponent'
import SelectableComponent from './inputs/SelectableComponent'
import TextareaComponent from './inputs/TextareaComponent'
import CheckboxComponent from './inputs/CheckboxComponent'
import RadioComponent from './inputs/RadioComponent'
import FileComponent from './inputs/FileComponent'

export default {
  name: 'FormGroupComponent',
  components: {
    FileComponent, RadioComponent, CheckboxComponent, TextareaComponent, SelectableComponent, InputTextComponent},
  props: ['label', 'id', 'value', 'name', 'placeholder', 'errorMessage', 'helpText', 'type', 'hasDanger', 'viewStyle', 'inputClass', 'options', 'checkboxes', 'radios'],
  methods: {
    filter: function (name) {
      for (let er in this.errorMessage) {
        if (er === name) {
          this.hasDanger = true
          return this.errorMessage[er]
        }
      }

      this.hasDanger = false
      return ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/form/FormGroupComponent.vue